import React from "react"

const Map = () => {
  return(
    <div style={{ height: "500px"}}>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10642.023435323266!2d16.3979302!3d48.1776042!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xbc2ba7ad2b6f1f1f!2sAgape%20Wien!5e0!3m2!1sde!2sat!4v1601309716559!5m2!1sde!2sat"
      width="100%" height="100%" frameBorder="0" style={{ border:0 }} allowFullScreen={false} aria-hidden="false"/>
    </div>
  )
}

export default Map